import { useState } from 'react'
import Kyc_lottie_animation from '../../../../animations/kyc_lottie_animation/Kyc_lottie_animation'
import Proceed_btn from '../../../../common_components/common_btn/proceed_btn/Proceed_btn'
import Kyc_step_content from './kyc_step_content/Kyc_step_content'
import "./Kyc_tab_content.css"

function Kyc_tab_content() {
  const [showKycStep, setShowKycStep] = useState(false);

  const handleProceedClick = () => {
    setShowKycStep(true);
  }

  return (
    <section className='Kyc_tab_content'>
      {/* Show lottie + button only if showKycStep is false */}
      {!showKycStep && (
        <div className="kyc_lottie_holder">
          <Kyc_lottie_animation />
          <div className="btn_holder text_center">
            <Proceed_btn 
              btnText="Complete Your KYC" 
              className="save_changes_btn" 
              onClick={handleProceedClick} 
            />
          </div>
        </div>
      )}

      {/* Show KYC step content only after clicking */}
      {showKycStep && <Kyc_step_content />}
    </section>
  )
}

export default Kyc_tab_content
